import { Content } from '../../types';

export const emeraldCaveContent: Content = {
  title: 'מערת האמרלד ואיי מחוז טראנג - טיול יום בלתי נשכח',
  imageUrl: '/images/thailand/emerald-cave/emerald-cave-wide.jpeg',
  introduction:
    'דרום תאילנד שופע באיים קסומים ובנופים עוצרי נשימה, אך ישנם מקומות נדירים ביופיים שכדאי להקדיש להם ביקור מיוחד. אחד מהם הינו מערת האמרלד (Morakot Cave), הנמצאת באי Ko Mook שבמחוז טראנג. המערה הינה חלק בלתי נפרד מטיול היום הפופולרי "4 האיים", היוצא לרוב מהאי קו לנטה וכולל ביקור באיים נוספים באזור. כאן נרחיב ונספר לכם אודות החוויה הייחודית של ביקור במערת האמרלד, נספר על האיים הכלולים בטיול וניתן טיפים שימושיים למטיילים.',
  sections: [
    {
      title: 'מערת האמרלד - פלא טבע חבוי',
      type: 'text',
      content:
        'מערת האמרלד הינה מנהרה ימית שאורכה כ-80 מטרים וברובה חשוכה לחלוטין. הדרך היחידה לעבור אותה הינה בשחייה, בליווי מדריכים מנוסים ופנסים. למרות האתגר הקל הכרוך בכניסה אליה, החוויה שממתינה בסופה שווה כל מאמץ - עם היציאה מהמערה, מתגלה לגונה חלומית, בעלת חוף חול לבן ומים צלולים בגוון טורקיז-ירקרק, המוקפת בצוקי גיר נישאים המכוסים בצמחייה טרופית עבותה.<br /><br />האפקט הוויזואלי המרשים של הלגונה נוצר הודות לקרני השמש החודרות דרך פתח המערה ומשתקפות על המים בגוון ייחודי של אמרלד ומכאן גם שמה של המערה. זהו מחזה טבע מרהיב, שנראה כאילו נלקח מתוך סיפור אגדה.',
    },
    {
      title: 'מתי לבקר?',
      type: 'text',
      content:
        'הזמן המומלץ ביותר לבקר במערת האמרלד, הינו בשעות הבוקר המאוחרות או בצהריים, כאשר השמש נמצאת בזווית הטובה ביותר לחדירת האור, מה שמעצים את האפקט הירקרק של המים. יש לקחת בחשבון שמדובר באתר תיירות פופולרי ולכן בשעות העומס ייתכן עומס מבקרים. כמו כן, חשוב לשמור על ניקיון המקום ולא להשליך פסולת כדי לשמר את יופיו הטבעי.',
    },
    {
      title: 'האיים הכלולים בטיול "4 האיים"',
      type: 'sub-headers',
      description:
        'מעבר למערת האמרלד, טיול היום כולל ביקור בשלושה איים נוספים, המציעים חופים לבנים, מי טורקיז ושוניות עשירות בחיים ימיים:',
      content: [
        {
          subtitle: 'קו נגאי (Ko Ngai)',
          text: 'אי קטן עם חופים חוליים לבנים ונופים מרהיבים. זהו יעד אידיאלי לשנורקלינג הודות לשוניות האלמוגים הסמוכות אליו.',
        },
        {
          subtitle: 'קו קרדאן (Ko Kradan)',
          text: 'אחד האיים היפים ביותר במחוז טראנג, המפורסם בזכות חופיו הבתוליים ומימיו הצלולים, שהופכים אותו לאחד מאתרי השנורקלינג הטובים באזור.',
        },
        {
          subtitle: "קו צ'ואק (Ko Chuek)",
          text: 'אי קטן עם צוקים דרמטיים ושונית אלמוגים צבעונית, שבה ניתן לראות דגים טרופיים ומגוון בעלי חיים ימיים.',
        },
        {
          subtitle: 'חווית הטיול',
          text: 'טיול זה מציע שילוב מושלם בין הרפתקה, נופים קסומים ושנורקלינג עוצר נשימה - חוויה בלתי נשכחת לכל חובבי הטבע והים.',
        },
      ],
    },
    {
      title: 'איך מגיעים?',
      type: 'sub-headers',
      description: 'ניתן לצאת לטיול היום "4 האיים" מכמה מוקדים בדרום תאילנד:',
      content: [
        {
          subtitle: 'קו לנטה',
          text: 'זהו אחד המוקדים הפופולריים ביותר לצאת ממנו לטיול זה, עם סיורים מאורגנים היוצאים מדי יום.',
        },
        {
          subtitle: 'מחוז טראנג',
          text: 'ניתן לקחת סירה מקומית או להצטרף לטיול מודרך היוצא מהיבשת.',
        },
        {
          subtitle: 'קו מוק (Ko Mook)',
          text: 'למי שכבר שוהה באי, אפשר להגיע למערת האמרלד ישירות באמצעות סירת לונגטייל מקומית.',
        },
      ],
    },
    {
      title: 'טיפים חשובים לטיול',
      type: 'sub-headers',
      description: 'כדי שהחוויה תהיה מושלמת, הנה כמה טיפים חשובים:',
      content: [
        {
          subtitle: 'ציוד מומלץ',
          text: 'בגד ים, מגבת, קרם הגנה, משקפי שמש, מצלמה עמידה במים ונעליים נוחות.',
        },
        {
          subtitle: 'נוחות במים',
          text: 'מכיוון שהמעבר במערה כרוך בשחייה, מומלץ להצטייד בחגורת הצלה למי שאינו שחיין מנוסה.',
        },
        {
          subtitle: 'שימור הטבע',
          text: 'כדי לשמור על הסביבה הימית, מומלץ להשתמש בקרם הגנה ידידותי לשונית ולא להשליך אשפה באיים או במים.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        'בשורה התחתונה, טיול יום ל"4 האיים" וביקור במערת האמרלד הינו אחת החוויות הבלתי נשכחות בדרום תאילנד. בין אם אתם חובבי הרפתקאות, טבע או פשוט מחפשים חופים קסומים עם מים צלולים - זהו טיול שלא תרצו לפספס. תכננו את הביקור בהתאם לשעות התאורה האופטימליות, הקפידו על ציוד מתאים וצאו למסע קסום אל אחת מפינות החמד היפות ביותר בתאילנד!',
      isBold: true,
    },
  ],
};
